import React, { useState, useEffect } from 'react';
import { Mail, Phone } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminCustomers = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const token = localStorage.getItem('token');
      
      // Fetch all orders
      const ordersResponse = await axios.get(`${API}/orders`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Group orders by customer email
      const customersMap = new Map();
      ordersResponse.data.forEach(order => {
        const email = order.shipping_info.email;
        if (!customersMap.has(email)) {
          customersMap.set(email, {
            name: `${order.shipping_info.first_name} ${order.shipping_info.last_name}`,
            email: email,
            phone: order.shipping_info.phone,
            orders: 1,
            totalSpent: order.total
          });
        } else {
          const customer = customersMap.get(email);
          customer.orders += 1;
          customer.totalSpent += order.total;
        }
      });
      
      setCustomers(Array.from(customersMap.values()));
    } catch (error) {
      console.error('Error fetching customers:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-8">
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-8">
      <h1 className="text-4xl font-bold mb-8 text-slate-800">Customers Management</h1>

      <Card className="border-2">
        <CardHeader>
          <CardTitle>All Customers ({customers.length})</CardTitle>
        </CardHeader>
        <CardContent>
          {customers.length === 0 ? (
            <p className="text-center py-8 text-slate-600">No customers yet</p>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-slate-50">
                  <tr>
                    <th className="text-left p-3 text-slate-700">Name</th>
                    <th className="text-left p-3 text-slate-700">Email</th>
                    <th className="text-left p-3 text-slate-700">Phone</th>
                    <th className="text-left p-3 text-slate-700">Orders</th>
                    <th className="text-left p-3 text-slate-700">Total Spent</th>
                  </tr>
                </thead>
                <tbody>
                  {customers.map((customer, index) => (
                    <tr key={index} className="border-t hover:bg-slate-50">
                      <td className="p-3 font-medium text-slate-800">{customer.name}</td>
                      <td className="p-3 text-slate-600">
                        <div className="flex items-center gap-2">
                          <Mail className="h-4 w-4 text-slate-400" />
                          {customer.email}
                        </div>
                      </td>
                      <td className="p-3 text-slate-600">
                        <div className="flex items-center gap-2">
                          <Phone className="h-4 w-4 text-slate-400" />
                          {customer.phone}
                        </div>
                      </td>
                      <td className="p-3 text-slate-800">{customer.orders}</td>
                      <td className="p-3 font-semibold text-blue-600">
                        ${customer.totalSpent.toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminCustomers;